/*
* Scope: Singleton
* ComponentRegistry will register and get components based on parameters.
* Component - In general, any function. But since functions are already available with HmEventRegistry,
* this will be used whenever there is a need for a component (Class) to be fetched using just the name
* component (class).
*/
const ComponentRegistry = function () {
	let cmpRegistry = {};

	  return{
		/**
		 * Registering Component
		 */
		register:function(cmpName, comp){
			if(cmpName !== null && comp !== null){
				cmpRegistry[cmpName.toLowerCase()] = comp;
				return true;
			}else{
				return false;
			}
		},
		/**
		* function to check if the component exists
		*/
		exists: function(cmpName){
			return (cmpName && cmpRegistry[cmpName.toLowerCase()]);			
		},
		/**
		 * Get the component by cmpName
		 */
		get:function(cmpName){
			if(cmpName && cmpRegistry[cmpName.toLowerCase()]){
				return cmpRegistry[cmpName.toLowerCase()];
			}

			return null;
		}
	};
}();

export default ComponentRegistry;


// WEBPACK FOOTER //
// ./src/model/ComponentRegistry.js